/* Veyralum product gallery: arrows, swipe, keyboard and full-screen view */
(function(){
  var big = function(src){ return src ? src.replace(/([?&])width=\d+/, '$1width=2000') : src; };
  var arrow = function(dir){
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
  };
  var swipe = function(el, onLeft, onRight){
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function(e){ var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, {passive:true});
    el.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ el.dataset.auSwiped = '1'; setTimeout(function(){ delete el.dataset.auSwiped; }, 350); if(dx < 0) onLeft(); else onRight(); }
    }, {passive:true});
  };

  /* lightbox (one per page) */
  var box = null, boxImg, boxCount, boxItems = [], boxIdx = 0, lastFocus = null;
  var buildBox = function(){
    box = document.createElement('div');
    box.className = 'au-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product images');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="au-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="au-lightbox__nav au-lightbox__nav--prev" aria-label="Previous image">' + arrow('prev') + '</button>' +
      '<img class="au-lightbox__img" alt="">' +
      '<button type="button" class="au-lightbox__nav au-lightbox__nav--next" aria-label="Next image">' + arrow('next') + '</button>' +
      '<span class="au-lightbox__count" aria-live="polite"></span>';
    document.body.appendChild(box);
    boxImg = box.querySelector('.au-lightbox__img');
    boxCount = box.querySelector('.au-lightbox__count');
    box.querySelector('.au-lightbox__close').addEventListener('click', closeBox);
    box.querySelector('.au-lightbox__nav--prev').addEventListener('click', function(){ showBox(boxIdx - 1); });
    box.querySelector('.au-lightbox__nav--next').addEventListener('click', function(){ showBox(boxIdx + 1); });
    box.addEventListener('click', function(e){ if(e.target === box) closeBox(); });
    swipe(box, function(){ showBox(boxIdx + 1); }, function(){ showBox(boxIdx - 1); });
    document.addEventListener('keydown', function(e){
      if(box.hidden) return;
      if(e.key === 'Escape') closeBox();
      else if(e.key === 'ArrowLeft') showBox(boxIdx - 1);
      else if(e.key === 'ArrowRight') showBox(boxIdx + 1);
    });
  };
  var showBox = function(i){
    var n = boxItems.length;
    if(!n) return;
    boxIdx = (i + n) % n;
    var item = boxItems[boxIdx], want = big(item.src);
    boxImg.src = item.src;
    boxImg.alt = item.alt || '';
    var hi = new Image();
    hi.onload = function(){ if(boxItems[boxIdx] === item) boxImg.src = want; };
    hi.src = want;
    boxCount.textContent = n > 1 ? (boxIdx + 1) + ' / ' + n : '';
    box.classList.toggle('is-single', n < 2);
  };
  var openBox = function(items, i){
    if(!box) buildBox();
    boxItems = items;
    lastFocus = document.activeElement;
    showBox(i);
    box.hidden = false;
    document.documentElement.classList.add('au-lightbox-open');
    box.querySelector('.au-lightbox__close').focus();
  };
  function closeBox(){
    if(!box || box.hidden) return;
    box.hidden = true;
    document.documentElement.classList.remove('au-lightbox-open');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* galleries */
  document.querySelectorAll('.au-gallery').forEach(function(g){
    var main = g.querySelector('.au-gallery__main');
    var img = main ? main.querySelector('img') : null;
    if(!main || !img) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.au-thumb'));
    var n = thumbs.length;
    /* thumbnails in two rows: half the thumbnails per row, at least 5 columns */
    g.style.setProperty('--au-thumb-cols', Math.max(5, Math.ceil(n / 2)));
    var path = function(s){ return (s || '').replace(/^https?:/, '').split('?')[0]; };
    var idx = 0;
    for(var k = 0; k < n; k++){ if(thumbs[k].getAttribute('aria-current') === 'true'){ idx = k; break; } }
    var items = function(){
      if(!n) return [{ src: img.currentSrc || img.src, alt: img.alt }];
      return thumbs.map(function(t){ return { src: t.dataset.src, alt: t.dataset.alt }; });
    };

    main.classList.add('au-gallery__main--zoom');
    img.setAttribute('role', 'button');
    img.setAttribute('tabindex', '0');
    img.setAttribute('aria-label', 'Enlarge image');
    var open = function(){ if(main.dataset.auSwiped) return; openBox(items(), idx); };
    img.addEventListener('click', open);
    img.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); open(); } });

    if(n < 2) return;

    var counter = document.createElement('span');
    counter.className = 'au-gallery__count';
    counter.setAttribute('aria-live', 'polite');
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'au-gallery__nav au-gallery__nav--prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = arrow('prev');
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'au-gallery__nav au-gallery__nav--next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = arrow('next');
    main.appendChild(prev); main.appendChild(next); main.appendChild(counter);

    var marking = false;
    var render = function(){
      marking = true;
      thumbs.forEach(function(t, i){ var v = i === idx ? 'true' : 'false'; if(t.getAttribute('aria-current') !== v) t.setAttribute('aria-current', v); });
      marking = false;
      counter.textContent = (idx + 1) + ' / ' + n;
    };
    var go = function(i){ idx = (i + n) % n; thumbs[idx].click(); render(); };
    prev.addEventListener('click', function(){ go(idx - 1); });
    next.addEventListener('click', function(){ go(idx + 1); });
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ idx = i; setTimeout(render, 0); }); });
    swipe(main, function(){ go(idx + 1); }, function(){ go(idx - 1); });
    g.addEventListener('keydown', function(e){
      if(e.target.closest && e.target.closest('input,textarea,select')) return;
      if(e.key === 'ArrowLeft'){ e.preventDefault(); go(idx - 1); }
      else if(e.key === 'ArrowRight'){ e.preventDefault(); go(idx + 1); }
    });
    if('MutationObserver' in window){
      /* a colour choice swaps the main image: follow it */
      new MutationObserver(function(){
        var p = path(img.getAttribute('src'));
        for(var j = 0; j < n; j++){ if(path(thumbs[j].dataset.src) === p){ idx = j; break; } }
        render();
      }).observe(img, { attributes: true, attributeFilter: ['src'] });
      /* the theme clears all highlights when the image URL differs in form: restore ours */
      new MutationObserver(function(){ if(!marking) render(); }).observe(g.querySelector('.au-gallery__thumbs'), { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    }
    render();
  });
})();
